<app-hatch-defs></app-hatch-defs>

<div class="chart-card" #exportRef>
  <div class="chart-header">
    <span class="chart-title">Venta x día</span>
    <div class="export-actions">
      <button class="export-btn" (click)="exportar('png')" title="Exportar imagen">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
        IMG
      </button>
      <button class="export-btn" (click)="exportar('pdf')" title="Exportar PDF">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
        PDF
      </button>
    </div>
  </div>
  <dx-chart [dataSource]="ventasRango" [customizePoint]="customizePoint" class="venta-chart">
    <dxi-series valueField="totalPesos" argumentField="fecha" type="bar" name="Pesos" axis="pesos">
      <dxo-label [visible]="false"></dxo-label>
    </dxi-series>
    <dxi-series valueField="totalKg" argumentField="fecha" type="bar" name="Kg" axis="kg" color="#4f9ef8">
      <dxo-label [visible]="false"></dxo-label>
    </dxi-series>
    <dxi-value-axis name="pesos" position="left">
      <dxo-title text="Pesos ($)"></dxo-title>
    </dxi-value-axis>
    <dxi-value-axis name="kg" position="right">
      <dxo-title text="Kg"></dxo-title>
    </dxi-value-axis>
    <dxo-argument-axis argumentType="datetime">
      <dxo-tick-interval [days]="1"></dxo-tick-interval>
      <dxo-label format="dd/MM" [rotationAngle]="45" overlappingBehavior="rotate"></dxo-label>
    </dxo-argument-axis>
    <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
    <dxo-legend [visible]="false"></dxo-legend>
    <dxo-export [enabled]="false"></dxo-export>
  </dx-chart>
</div>
